/** Shared Y-axis scale for dashboard bar charts (hours cap). */
const BAR_MAX_HOURS = 8;

/** Shared Y-axis cap: at least 8h, grows when the visible range exceeds that. */
export function getChartScaleMaxHours(barData) {
  const peak = (barData ?? []).reduce((max, bar) => {
    const dayPeak = Math.max(bar.hours ?? 0, bar.planned ?? 0);
    return Math.max(max, dayPeak);
  }, 0);
  return Math.max(BAR_MAX_HOURS, peak);
}
